import { faObjectGroup, faSortNumericDown, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { Alert, Button, Form, FormGroup, Modal } from "react-bootstrap";
import { CheckLg, DashCircle, ExclamationTriangleFill } from "react-bootstrap-icons";
import { setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import { sortDocuments } from "../store/api/DocumentsAPI";
import { useDispatch } from "react-redux";

export default function ModalSortDocuments(props) {
    const { popData, setPopData } = props;
    const { show } = popData;
    const dispatch = useDispatch();
    const inputNumber = useRef();
    const [sortError, setSortError] = useState(null);
    const [isPending, setPending] = useState(false);
    function close() {
        setPending(false);
        setPopData({ show: false });
        setSortError(null);
    }
    function sort() {
        setSortError(null);
        if (inputNumber.current.value?.toString() === "") {
            setSortError("شماره آغازین وارد نشده است.");
            return;
        }
        const onSort = (res) => {
            setPending(res === "PENDING");

            if (res.Error) {
                setSortError(res.Error);
            }
            else if(res.Data) {
                close();
                setErrorDialog(dispatch, "success", "مرتب سازی اسناد");
            }
        }
        dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: "مرتب سازی اسناد",
            dialogText: 'آیا از مرتب سازی اسناد مطمئن هستید؟',
            okOperation: () => sortDocuments(inputNumber.current.value, onSort)
        }))
    }
    return (
        <Modal show={show} onHide={() => { }} size="sm" enforceFocus={true} autoFocus={true}>
            <Modal.Header className="headerStyle">

                <span>
                    <FontAwesomeIcon icon={faSortNumericDown} size="lg" />&nbsp;
                    مرتب سازی اسناد حسابداری
                </span>
                {!isPending &&
                    <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
                }
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {sortError && <Alert variant="danger"><ExclamationTriangleFill size={23} color="orange" />&nbsp;{sortError}</Alert>}
                <FormGroup>
                    <label>شماره آغازین:</label>
                    <Form.Control type="number" ref={inputNumber} defaultValue={1} />
                </FormGroup>
                <div className="mt-1">
                    <Button className="group-Btn" variant="success" disabled={isPending} onClick={sort}><CheckLg size={18} />&nbsp; شروع مرتب سازی</Button>
                    <Button className="group-Btn" variant="danger" onClick={close} disabled={isPending}><DashCircle size={18} />&nbsp;انصراف</Button>
                </div>
            </Modal.Body>
        </Modal>
    )

}